// extracted by mini-css-extract-plugin
export default {"frame":"Artwork_frame__7oy2n","artwork":"Artwork_artwork__B9HpH","artwork__fill":"Artwork_artwork__fill__RsqeX","artwork__fit":"Artwork_artwork__fit__hObrD"};